import React from 'react';
import './index.css';
import App from './App';
import reportWebVitals from "./common/reportWebVitals";
import {createRoot} from "react-dom/client";

// @ts-ignore
const container = createRoot(document.querySelector('body'));

container.render(
    <App />
);
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();



